import React, { useEffect, useState } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';


function Features() {
    const [features, setFeatures] = useState([]);
    useEffect(() => {
        fetch('freatures.json')
            .then(res => res.json())
            .then(data => setFeatures(data))
    }, [])
    return (
        <div id='features' className='max-w-7xl mx-auto px-6 pt-20'>
            <div className='text-center  mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">features</h3>
                <h1 className='text-5xl md:text-6xl xl:text-7xl font-bold'>What I Do</h1>
            </div>

            <ScrollAnimation animateIn='wobble'
                initiallyVisible={true}>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mx-5'>
                    {
                        features.map(feature => <div key={feature.id} className="card w-full border-2 border-transparent hover:border-[#ff014f] shadow-lg shadow-slate-600 rounded-lg p-5">
                            <div className="card-body">
                                <img src={feature?.icon} alt="" className='w-10 text-[#ff014f]' />
                                <h2 className="card-title">{feature.name}</h2>
                                <p>{feature.description}</p>

                            </div>
                        </div>)
                    }
                </div>
            </ScrollAnimation>
            <div className="divider mt-20"></div>
        </div>
    )
}

export default Features
